import React from 'react';
import { useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { adminKYCApi } from '@/api';
import { ProfileDocuments as RenderProfileDocuments } from '../../../investor/organisms/ProfileDocuments';
import { Loading } from '@/components';

export const InvestorDocuments = () => {
  const { id } = useParams();
  const { data, refetch, isLoading } = useQuery({
    queryKey: ['getDocumentRequests'],
    queryFn: () => adminKYCApi.getDocumentRequests(id),
    refetchInterval: 10000
  });
  const { data: questsDocs } = useQuery({
    queryKey: ['getQuestsDocuments'],
    queryFn: () => adminKYCApi.getQuestsDocuments(id)
  });

  if (isLoading) return <Loading />;

  if (!isLoading) {
    return (
      <RenderProfileDocuments
        documents={data ? data.data : null}
        questsDocs={questsDocs ? questsDocs.data : null}
        refetchDocs={refetch}
        viewMode={'admin'}
        investorId={id}
      />
    );
  }

  return null;
};
